import React from "react";

import "./App.css";
import MuiTable from "./components/MuiTable";

function App() {
  return (
    <div className="App">
      <MuiTable />
    </div>
  );
}

export default App;
